<div class="component-container">
  <div class="card text-center row has-float-btn">
    <ng-content select="[text]"></ng-content>
    <ng-content></ng-content>
    <div class="w-stretch pt-10">
      @if (title) {
        <div class="row1">
          <div class="row-inline grid-sm">
            <div class="cell iconbox"><img [src]="iconUrl" [width]="iconWidth" alt=""></div>
            <div class="cell fz-16">{{title}}</div>
          </div>
        </div>
      }
      <div class="row2">
        <div class="text-large mt-2">{{value}}</div>
      </div>
    </div>
  </div>
</div>